import React from 'react'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { 
  AcademicCapIcon, 
  CarIcon, 
  BookOpenIcon, 
  ShieldCheckIcon, 
  ClipboardDocumentCheckIcon,
  BuildingOfficeIcon
} from '../icons/ServiceIcons'

const services = [
  {
    icon: AcademicCapIcon,
    title: 'Teen Driver Education',
    description: 'Comprehensive 30-hour classroom and 14-hour behind-the-wheel training for new drivers aged 15.5+.',
    badge: 'Most Popular',
    href: '/courses#teen',
  },
  {
    icon: CarIcon,
    title: 'Adult Driving Lessons',
    description: 'Customized lessons for adult learners at any skill level. Flexible scheduling available.',
    href: '/courses#adult',
  },
  // {
  //   icon: BookOpenIcon,
  //   title: 'Online Driver Education',
  //   description: 'DMV-approved online courses you can complete at your own pace from anywhere.',
  //   href: '/courses#online',
  // },
  // {
  //   icon: ShieldCheckIcon,
  //   title: 'Defensive Driving',
  //   description: 'Learn advanced techniques to stay safe and potentially reduce your insurance premiums.',
  //   href: '/courses#defensive',
  // },
  {
    icon: ClipboardDocumentCheckIcon,
    title: 'Road Test Preparation',
    description: 'Intensive preparation for your DMV road test with mock tests and expert feedback.',
    href: '/courses#road-test',
  },
  // {
  //   icon: BuildingOfficeIcon,
  //   title: 'Corporate Training',
  //   description: 'Fleet safety and driver training programs for businesses and organizations.',
  //   href: '/courses#corporate',
  // },
]

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
}

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
    },
  },
}

export default function Services() {
  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <div className="text-accent font-heading font-semibold text-sm uppercase tracking-wider mb-2">
            Our Services
          </div>
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-primary mb-4">
            Comprehensive Driving Programs
          </h2>
          <p className="text-lg text-secondary-text max-w-2xl mx-auto">
            From first-time drivers to experienced motorists, we offer programs tailored to your needs.
          </p>
        </motion.div>

        {/* Services Grid */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          {services.map((service, index) => {
            const Icon = service.icon
            const isYellow = index === 0 || index === 5
            
            return (
              <motion.div
                key={service.title}
                variants={cardVariants}
                whileHover={{ y: -8, transition: { duration: 0.2 } }}
                className="bg-white p-6 rounded-lg shadow-soft hover:shadow-lift transition-shadow"
              >
                <div className={`w-16 h-16 ${isYellow ? 'bg-accent' : 'bg-primary/10'} rounded-lg flex items-center justify-center mb-4`}>
                  <Icon className={`w-8 h-8 ${isYellow ? 'text-primary' : 'text-primary'}`} />
                </div>
                {service.badge && (
                  <span className="inline-block bg-primary text-white text-xs font-heading font-semibold px-3 py-1 rounded-full mb-3">
                    {service.badge}
                  </span>
                )}
                <h3 className="text-xl font-heading font-bold text-primary mb-3">
                  {service.title}
                </h3>
                <p className="text-secondary-text mb-4">
                  {service.description}
                </p>
                {/* <Link
                  to={service.href}
                  className="text-primary font-heading font-semibold hover:text-accent transition-colors inline-flex items-center gap-1"
                >
                  Learn More <span>&gt;</span>
                </Link> */}
              </motion.div>
            )
          })}
        </motion.div>
      </div>
    </section>
  )
}

